import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01">
            <h2>{{ 'home.planningGroup.Automated planning groups' | translate }}</h2>
        </div>
        <div class="tablewrapper">
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
                <thead>
                    <tr>
                        <th>{{ 'home.planningGroup.Course' | translate }}</th>
                        <th>{{ 'home.planningGroup.Planning group' | translate }}</th>
                        <th>{{ 'home.planningGroup.Users' | translate }}</th>
                        <th>{{ 'home.planningGroup.Version' | translate }}</th>
                        <th>{{ 'home.planningGroup.Site' | translate }}</th>
                        <th>{{ 'home.planningGroup.Status' | translate }}</th>
                        <th ng-if="vm.PrivilegeService.canViewAutomatedPlanningGroups()">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td ng-if="vm.PrivilegeService.canViewAutomatedPlanningGroups()">
                            <a ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({ id: item.courseId, planningGroupId: item.id})">
                                {{ item.courseActiveI18n.name }}
                            </a>
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.userCount }}</td>
                        <td>{{ item.courseVersion.name }}</td>
                        <td ng-if="item.siteNames">
                            <span style="display: block; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                title="{{ item.siteNames }}">{{ item.siteNames }}</span>
                        </td>
                        <td ng-if="!item.siteNames">
                            {{ 'home.planningGroup.All sites' | translate }}
                            </br>
                            <small ng-if="item.excludeExternalSites === 1">({{ 'home.planningGroup.External site excluded' | translate }})</small>
                        </td>
                        <td>{{ vm.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.LABELS[item.status] }}</td>
                        <td class="actions" ng-if="vm.PrivilegeService.canViewAutomatedPlanningGroups()">
                            <a
                                ng-if="vm.PrivilegeService.canManageAutomatedPlanningGroups()"
                                class="btn edit"
                                ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({ id: item.courseId, planningGroupId: item.id})">
                                {{ 'general.Edit' | translate }}
                            </a>
                            <a
                                ng-if="!vm.PrivilegeService.canManageAutomatedPlanningGroups()"
                                class="btn view"
                                ui-sref="authorized.courses.courses.edit.occurrence.automated.edit.general({ id: item.courseId, planningGroupId: item.id})">
                                {{ 'general.View' | translate }}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})

export default class {
    constructor ($translate, lodash, moment, DATATABLES, ListFactory,
                 AutomatedPlanningGroupResource, PrivilegeService,
                 AUTOMATED_PLANNING_GROUP_STATUS_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.PrivilegeService = PrivilegeService;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.queryGroups.bind(this));
        this.list.fetch({ pageSize: 10, expand: 'courseVersion,courseActiveI18n,sites' });
    }

    // pagination calls list.fetch() directly, so the decoration has to happen on every
    // response rather than on the promise of the first one
    queryGroups (query, postParameters, callback) {
        return this.AutomatedPlanningGroupResource.query(query, postParameters, (items, headers) => {
            // an empty site list means the group covers every site, the column says so instead
            items.forEach(item => {
                item.siteNames = (item.sites || []).map(site => site.name).join(', ');
            });
            callback(items, headers);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/planningGroups/index.js